/**
 * T-212 (Teil B) — „ein Entwurf hat sich geändert“ (gespeichert, gesendet,
 * gelöscht). Der Delta-Poll meldet Entwürfe bewusst nicht; Posteingang und
 * Lesefenster laden ihren Entwurfs-Index deshalb über dieses Signal nach.
 */
type Hoerer = (mailbox: string) => void;

const hoerer = new Set<Hoerer>();

export function meldeEntwurfGeaendert(mailbox: string): void {
    for (const h of Array.from(hoerer)) {
        try {
            h(mailbox);
        } catch {
            /* ein kaputter Hörer darf die anderen nicht aufhalten */
        }
    }
}

export function abonniereEntwurfAenderung(h: Hoerer): () => void {
    hoerer.add(h);
    return () => {
        hoerer.delete(h);
    };
}
